import { defineMessages } from 'react-intl';

const point12Messages = defineMessages({
    terminalbox: {
        id: 'terminal-box-point12',
        defaultMessage: 'Terminal Box',
    },
    terminalboxPlural: {
        id: 'terminal-box-point12-plural',
        defaultMessage: 'Terminal Boxes',
    },
    coupler: {
        id: 'coupler-point12',
        defaultMessage: 'Coupler',
    },
    couplerPlural: {
        id: 'coupler-point12-plural',
        defaultMessage: 'Couplers',
    },
    odf: {
        id: 'odf-point12',
        defaultMessage: 'ODF',
    },
    odfPlural: {
        id: 'odf-point12-plural',
        defaultMessage: 'ODFs',
    },
    switch: {
        id: 'switch-point12',
        defaultMessage: 'Switch',
    },
    switchPlural: {
        id: 'switch-point12-plural',
        defaultMessage: 'Switches',
    },
    rack: {
        id: 'rack-point12',
        defaultMessage: 'Rack',
    },
});

const shortPoint12Messages = defineMessages({
    terminalbox: {
        id: 'short-terminal-box-point12',
        defaultMessage: 'TB',
    },
    coupler: {
        id: 'short-coupler-point12',
        defaultMessage: 'C',
    },
    odf: {
        id: 'short-poplayer12-point12',
        defaultMessage: 'ODF',
    },
    rack: {
        id: 'short-rack-point12',
        defaultMessage: 'R',
    },
});

export { point12Messages, shortPoint12Messages };
